export default __webpack_public_path__ + "static/media/87.0085bea4.jpg";